import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCartIcon } from 'lucide-react';
export function CTASection() {
  return <section id="comprar" className="py-24 px-6 md:px-12 bg-sage-600 w-full flex justify-center text-center" data-id="element-8">
      <div className="max-w-3xl w-full" data-id="element-9">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col items-center" data-id="element-10">
          <h2 className="text-4xl md:text-5xl font-playfair text-white mb-6" data-id="element-11">
            Comience su transformación hoy
          </h2>
          <p className="text-xl text-sage-100 font-lato font-light mb-10 max-w-xl" data-id="element-12">
            El Día 1 es el día que usted decide empezar.
          </p>

          <a href="https://allopenwellness.com/cart/46817807761539:1" target="_blank" rel="noopener noreferrer" className="bg-cream-50 hover:bg-white text-sage-600 font-lato font-bold text-xl px-10 py-5 rounded-md transition-all duration-300 shadow-xl hover:shadow-2xl transform hover:-translate-y-1 w-full sm:w-auto mb-4 flex items-center justify-center gap-3 mx-auto" aria-label="Comprar y descargar ahora" data-id="element-13">
            <ShoppingCartIcon className="w-6 h-6" data-id="element-14" />
            Comprar y descargar ahora
          </a>

          <p className="text-sm text-sage-200 italic mb-12" data-id="element-15">
            Empiece cuando quiera: Día 1 = el día que usted comienza.
          </p>

          <div className="bg-sage-700/50 p-6 rounded-lg border border-sage-500/30 text-left" data-id="element-16">
            <h4 className="text-white font-playfair font-bold text-lg mb-2" data-id="element-17">
              Nota importante
            </h4>
            <p className="text-sage-100 font-lato text-sm leading-relaxed" data-id="element-18">
              Este material es educativo y no sustituye atención médica. Si
              usted tiene condiciones de salud o toma medicación, consulte con
              su profesional antes de realizar cambios importantes.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}